import { generateBooleanSchema, generateColorSchema, generateRootObjectSchema, generateStringSchema, generateUrlSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { TextParticleSpec, ImageParticleSpec, ButtonParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("CTA Horizontal Card 2", generateRootObjectSchema({
    container: generateAtomContainerSchema({
        defaultValues: { themeMode: 'overlay' },
        uneditableFields: { background: false }
    }),
    overlayPadding: generateStringSchema("Overlay Padding", "The padding (inset) of the overlay text/buttons relative to the background image.", {
        defaultValue: '2.5rem 2.25rem'
    }),
    textBackgroundColor: generateColorSchema("Background Color for Text", "Pick a color for Text area background"),
    link: generateUrlSchema("Link", "The link for this media item. The default link will be generated from the slug if this is not provided (and the slug is)."),
    headerText: TextParticleSpec.generateSchema("Heading Text", "Please enter a text for Heading", {
        defaultValues: { size: '3rem', style: 'normal', weight: '900', container: { themeMode: 'overlay' } }
    }),
    bodyText: TextParticleSpec.generateSchema("Subheading text", "Please enter a text for Body here", {
        defaultValues: { size: '1.25rem', style: 'normal', weight: '400', }
    }),
    inlineText1: TextParticleSpec.generateSchema("Bottom Text 1", "Please enter a text for the first inline", {
        defaultValues: { size: '1.25rem', style: 'normal', weight: '400', }
    }),
    inlineText2: TextParticleSpec.generateSchema("Bottom Text 2", "Please enter a text for the second inline", {
        defaultValues: { size: '1.25rem', style: 'normal', weight: '400', }
    }),
    inlineText3: TextParticleSpec.generateSchema("Bottom Text 3", "Please enter a text for the third inline", {
        defaultValues: { size: '1.25rem', style: 'normal', weight: '400', }
    }),
    thumbnail: ImageParticleSpec.generateSchema("Thumbnail", "The image thumbnail for the background of the card.", {
        defaultValues: { sizing: 'cover', hoverZoomEnabled: true, role: 'general' },
    }),
    ctaButton: ButtonParticleSpec.generateSchema("CTA Button", "The CTA button.", {
        defaultValues: {
            showImage: false, container: {
                themeMode: 'primary', background: { visible: true, useHighlightColor: true }, border: { visible: true, radius: '50%' },
                padding: '0.75rem 0.75rem', width: 'max-content',
            }, text: { size: '1rem', weight: '600' }
        }
    }),
    reverseOrientation: generateStringSchema("Reverse Orientation", "Reverse Text and Image orientations", {
        choices: ['image', 'text'],
        choiceTitles: ["Image First", "Text First"]
    }),
    scaleToThumbnailAspectRatio: generateBooleanSchema("Scale to Thumbnail Aspect Ratio", "Scale the width and height of the card to the thumbnail's aspect ratio.", {
        defaultValue: true,
    }),
}));
